import React from 'react';
import ReactDOM from 'react-dom';
import './stylesheet/application.css';
import '@customink/design-tokens/build/ci_light/css/variables.css';
import '@customink/pigment-react/lib/colors.css';
import '@customink/pigment-react/lib/fonts.css';
import * as Sentry from '@sentry/react';
import { knownAuthErrors } from '~/contexts/Auth/error';
import App from './app';

const isProduction = import.meta.env.MODE === 'production';

Sentry.init({
    release: import.meta.env.VITE_RELEASE,
    dsn: import.meta.env.ACCOUNTS_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
        new Sentry.BrowserTracing(),
        new Sentry.Replay({
            maskAllText: isProduction,
            maskAllInputs: isProduction,
            blockAllMedia: isProduction,
        }),
    ],
    beforeSend(event) {
        // do not log known auth related errors
        if (
            event.exception?.values?.every((exception) => exception.value && knownAuthErrors.includes(exception.value))
        ) {
            return null;
        }
        return event;
    },
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: isProduction ? 0.2 : 1.0,
});

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root_accounts_ui'),
);
